/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ListPraetorComponentsParams = zod.object({
	version: zod.string().optional()
});

export type ListPraetorComponentsParams = zod.input<typeof ListPraetorComponentsParams>;
export type ListPraetorComponentsParamsOutput = zod.output<typeof ListPraetorComponentsParams>;
